export interface ITranslatorVisitor {
    visit(...args: unknown[]): void;
}
